export default __webpack_public_path__ + "static/media/icon-20-icn-poi-close.a4c96a70.svg";